<style>

.bg{
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-image: url("/i/signup-bg-wizard.jpg");
  background-size: cover;
  color: black;
  padding: 20px;
  overflow-y: scroll;
}

.margin{
  margin-top: 50px;
}

.spinner{
  margin-top: 40px;
  text-align: center;
}

</style>

<div class="bg">
  <div class="title-signup">Generating Encryption Keys...</div>
  
  <div class="spinner">
    <Spinner></Spinner>
  </div>
  
  <div class="margin small">This might take a minute.</div>
  <div class="margin small">Your encryption keys are used to store and transmit your data securely.</div>
  
</div>



<script>

import {push, pop, replace, location, link} from 'svelte-spa-router';

import Spinner from "../../../../components/Spinner.svelte";
import Signup from "../../../../helpers/Signup.js";

import forge from "node-forge";

import { onMount } from "svelte";
onMount(async () => {
  
  try {
    Signup.verifyPersonalObject();
  } catch (e) {
    console.log("error:", e);
    
    if (e == "Must start from beginning") {
      document.location = "/";
    }
    
    return;
  }
  
  // if signup is already complete, then we push the user outta here...
  let signupComplete = Signup.getPersonalObject("signupComplete");
  if (signupComplete == true) {
    document.location = "/";
    return;
  }
  
  // have we already generated keys?
  // Signup.saveToPersonalObject("keys", []);
  let keysSaved = Signup.getPersonalObject("keysSaved");
  if (keysSaved == true) {
    replace("/signup/profile/personal/phone");
    return;
  }
  
  // generate shared keys
  forge.pki.rsa.generateKeyPair({bits: 4096, workers: 2}, async function(err, keypair) {
    
    if (err == null) {
      
      let publicKey = forge.pki.publicKeyToPem(keypair.publicKey);
      
      // create public certificate for pkcs7
      let cert = forge.pki.createCertificate();
      cert.publicKey = keypair.publicKey;
      cert.serialNumber = "01";
      cert.validity.notBefore = new Date();
      cert.validity.notAfter = new Date();
      cert.validity.notAfter.setFullYear(cert.validity.notBefore.getFullYear() + 20);
      
      let attrs = [{
        name: "commonName",
        value: "shadowUser"
      }];
      cert.setSubject(attrs);
      cert.setIssuer(attrs);
      cert.setExtensions([{
        name: "basicConstraints",
        cA: true
      }, {
        name: "keyUsage",
        keyCertSign: true,
        digitalSignature: true,
        nonRepudiation: true,
        keyEncipherment: true,
        dataEncipherment: true
      }, {
        name: "subjectAltName",
        altNames: [{
          type: 6, // URI
          value: "https://hangingout.today/"
        }]
      }]);
      
      cert.sign(keypair.privateKey);
      
      // console.log("cert", cert);
      
      let saveCert = forge.pki.certificateToPem(cert);
      
      let password = Signup.getPersonalObject("password");
      // console.log("password:", password);
      
      let privateKeyOut = forge.pki.encryptRsaPrivateKey(keypair.privateKey, password);
      
      // console.log("privateKeyOut", privateKeyOut);
      
      await Signup.saveToPersonalObject("tempPassword", password);
      await Signup.saveToPersonalObject("keys", {cert: saveCert, pkey: privateKeyOut});
      await Signup.saveToPersonalObject("keysSaved", true);
      
      // console.log("saving user info");
      await Signup.saveKeys();
      
      push("/signup/profile/personal/phone");
    }
    
  });
  
  
});

</script>